module.exports = __webpack_public_path__ + "static/media/file-export.d03f1e1d.svg";